import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Col, Modal, Row } from "react-bootstrap";
import shape from "../../../assets/images/team/feture-bg-shape.png";
import dots from "../../../assets/images/team/dots-1.png";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

const Mentors = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [mentors, setMentors] = useState(null);

  const handleShow = (mentor) => {
    setSelectedMentor(mentor);
    setShow(true);
  };

  useEffect(() => {
    fetchCMSData();
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      const filteredTeachers = res.data.data.sort(
        (a, b) => Number(a.tec_position) - Number(b.tec_position)
      );
      setCmsData(filteredTeachers);
      setMentors(res.data.home_setting);
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1.1 },
      },
    ],
  };
  const aboutUsItems = cmsData.filter((item) => item.type === "our_mentors");

  return (
    <>
      {status == 1 ? (
        <section className="team py-60 bg-white">
          <img src={dots} alt="" className="dots" />
          <Row className="align-items-center">
            <Col xl={5}>
              <div className="team_one__content mb-64 mb-xl-0 sec-title">
                <div className="heading mb-16">
                  <h6 className="color-primary mb-8">–––– Our Mentors</h6>
                  {mentors && mentors[0]?.mentors_title && (
                    <h2
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          mentors[0].mentors_title || ""
                        ),
                      }}
                    />
                  )}
                </div>
              </div>
            </Col>

            <Col xl={7}>
              <Slider {...settings} className="all_teams py-60">
                {aboutUsItems
                  ?.slice()
                  .sort((a, b) => {
                    const aLastName = a.name.split(" ")[1];
                    const bLastName = b.name.split(" ")[1];
                    return aLastName.localeCompare(bLastName);
                  })
                  .map((item, index) => (
                    <div className="px-2" key={index}>
                      <div className="team__card mb-24">
                        <div className="team__img_block">
                          <img
                            src={item?.image ? `${imagePath}${item.image}` : ""}
                            alt={item.name}
                            className="team_img"
                          />
                          <div className="team__content_block">
                            <div className="team__text_block">
                              <h5 className="mb-8">
                                <Link to="#">{item.name}</Link>
                              </h5>
                              <ul className="team__info unstyled mb-16">
                                <li>
                                  {/* <span>
                                    <FaGraduationCap />
                                  </span> */}
                                  {item.founder_post}
                                </li>
                              </ul>
                              <p
                                className="team_info_text mb-24"
                                // dangerouslySetInnerHTML={{
                                //   __html: truncateWords(item.description,2),
                                // }}
                              >
                                <Link
                                  onClick={() => handleShow(item)}
                                  className="educate-btn sm"
                                >
                                  <span className="educate-btn__curve"></span>
                                  See Detail
                                </Link>
                              </p>
                              <img
                                src={shape}
                                alt="shape_Bottom"
                                className="text_block_bg_shape"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </Col>
          </Row>

          {show && selectedMentor && (
            <Modal
              show={show}
              onHide={handleClose}
              centered
              className="enquire_form mentor"
              backdrop="static"
              size="lg"
            >
              <button
                type="button"
                className="custom-close-btn"
                onClick={handleClose}
              >
                ×
              </button>

              <Modal.Body>
                <div className="team__model">
                  <Row className="align-items-center">
                    <Col lg={5} md={6}>
                      <div className="modal_content_left">
                        <img
                          src={
                            selectedMentor?.image
                              ? `${imagePath}${selectedMentor.image}`
                              : ""
                          }
                          alt={selectedMentor?.name}
                          className="team_img"
                        />
                        <div className="mentor_info">
                          <h5 className="mb-8">
                            <Link to="#">{selectedMentor?.name}</Link>
                          </h5>
                          <p>{selectedMentor?.founder_post}</p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={7} md={6}>
                      <div className="team_right_info">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: selectedMentor?.description,
                          }}
                        ></p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Modal.Body>
            </Modal>
          )}
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default Mentors;
